import { Link } from 'react-router-dom';

/**
 * Donate to Souqli.
 *
 * Donations come TO Souqli - they are not claimed by other shoppers. A donor
 * posts an item, receives a free locker drop-off label routing it to Souqli's
 * collection address, and the Souqli team redistributes it to the people and
 * causes who need it. No public "free shelf" claiming, no claimer fee.
 */
export default function FreeAndDonations() {
  return (
    <div className="bg-cream">
      <header className="section-dark relative overflow-hidden text-cream" style={{ background: '#221A12' }}>
        <div className="absolute inset-0 mashrabiya opacity-[0.07] pointer-events-none" />
        <span className="absolute -right-16 -top-20 w-72 h-72 rounded-full bg-gold/20 blur-3xl pointer-events-none" />
        <span className="absolute -left-10 -bottom-24 w-64 h-64 rounded-full bg-gold/10 blur-3xl pointer-events-none" />
        <div className="relative max-w-[1800px] mx-auto px-6 py-16 grid md:grid-cols-2 gap-10 items-end">
          <div>
            <div className="stamp text-cream/70 mb-3">Give to Souqli</div>
            <h1 className="display text-5xl md:text-6xl">Donate a piece.<br /><span className="text-gold-light">We pass it on.</span></h1>
            <p className="mt-5 text-cream/80 max-w-[58ch] leading-relaxed">
              Send your pre-loved fashion, tech and lifestyle pieces to Souqli, and we redistribute them to the people and causes who need them most. It costs you nothing - we email you a free locker drop-off label.
            </p>
            <div className="mt-7 flex gap-3">
              <Link to="/dashboard/donate" className="btn btn-gold">Donate an item</Link>
              <Link to="#how" className="btn btn-outline-cream">How it works</Link>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-2 sm:gap-3 max-w-md md:ml-auto">
            <div className="notched-sm bg-cream/10 p-3 sm:p-5">
              <div className="display text-3xl text-gold-light">£0</div>
              <div className="stamp text-cream/70 mt-1">to donate</div>
            </div>
            <div className="notched-sm bg-cream/10 p-3 sm:p-5">
              <div className="display text-3xl text-gold-light">Free</div>
              <div className="stamp text-cream/70 mt-1">locker drop-off</div>
            </div>
            <div className="notched-sm bg-cream/10 p-3 sm:p-5">
              <div className="display text-3xl text-gold-light">100%</div>
              <div className="stamp text-cream/70 mt-1">passed on</div>
            </div>
          </div>
        </div>
        <div className="gold-rule" />
      </header>

      <section className="max-w-[900px] mx-auto px-6 pt-16 text-center">
        <div className="stamp text-gold-dark text-[10px]">WHY WE COLLECT DONATIONS</div>
        <h2 className="display text-3xl mt-2">The purpose</h2>
        <p className="text-[15px] text-mute mt-3 leading-relaxed">
          Every year, wearable clothes, working tech and usable goods are thrown away while people
          nearby go without. Souqli donations exist to close that gap: we give your pre-loved pieces a
          second life by passing them, free of charge, to individuals and community causes who need them
          most. It keeps good things out of landfill and puts them into the hands of people they can help.
        </p>
      </section>

      <section id="how" className="max-w-[1100px] mx-auto px-6 py-16">
        <h2 className="display text-3xl text-center">How donating works</h2>
        <p className="text-center text-mute mt-2 max-w-[52ch] mx-auto">Four simple steps, no cost to you. Souqli handles the rest.</p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-10">
          {[
            { n: '1', t: 'Post your item', d: 'Add a few photos and an honest description from your dashboard.' },
            { n: '2', t: 'Get a free label', d: 'We email you a locker drop-off label - you pay nothing.' },
            { n: '3', t: 'Drop it at a locker', d: 'Leave the parcel at your nearest partner locker. It routes to Souqli.' },
            { n: '4', t: 'We pass it on', d: 'Our team checks each donation and gives it to someone who needs it.' },
          ].map((s) => (
            <div key={s.n} className="card p-6 text-center">
              <div className="w-10 h-10 mx-auto rounded-full bg-sage/15 text-sage-dark grid place-items-center display text-lg">{s.n}</div>
              <div className="display text-lg mt-3">{s.t}</div>
              <p className="text-[13px] text-mute mt-1.5 leading-snug">{s.d}</p>
            </div>
          ))}
        </div>

        <div className="card p-8 mt-12 text-center bg-sage/10 border-sage/25">
          <div className="stamp text-sage-dark text-[10px]">WHERE YOUR DONATION GOES</div>
          <h3 className="display text-2xl mt-2">Straight to people who need it</h3>
          <p className="text-[14px] text-mute mt-2 max-w-[60ch] mx-auto leading-relaxed">
            Every item you donate comes to the Souqli team, who check it and pass it on to individuals and good causes. Your generosity goes where it matters.
          </p>
          <Link to="/dashboard/donate" className="btn btn-primary mt-6">Donate an item</Link>
        </div>
      </section>
    </div>
  );
}
